import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-mb-lg column items-center q-gutter-md" }
const _hoisted_2 = {
  class: "row justify-center",
  style: {"width":"100%"}
}
const _hoisted_3 = {
  class: "row justify-evenly",
  style: {"width":"100%"}
}

import {
  PropType, computed,
} from 'vue';
import { RegisterPacientePersonalData } from 'src/types/initial-evaluation/evaluacion-personal';


export default /*#__PURE__*/_defineComponent({
  __name: 'InformacionAcademica',
  props: { modelValue: {
  type: Object as PropType<RegisterPacientePersonalData['academicInfo']>,
  required: true,
}},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;




const academicInfo = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_input, {
        modelValue: _unref(academicInfo).school,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(academicInfo).school) = $event)),
        name: "escuela",
        label: "Escuela o Institución",
        class: "col-12",
        color: "primary"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_q_input, {
        modelValue: _unref(academicInfo).grade,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(academicInfo).grade) = $event)),
        name: "Grado",
        label: "Grado",
        class: "col-4",
        color: "primary"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_input, {
        modelValue: _unref(academicInfo).group,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(academicInfo).group) = $event)),
        name: "Grupo",
        label: "Grupo",
        class: "col-4",
        color: "primary"
      }, null, 8, ["modelValue"])
    ])
  ]))
}
}

})